import { Box } from '@mui/material';
import React from 'react';

import { ItemsPerPage } from './index';

interface IPaginationControlsProps {
  pageSize: number;
  options: number[];
  onPageSizeChange: (newPageSize: number) => void;
  PaginationComponent: React.ComponentType<{ className?: string }>;
  disableItemsPerPage?: boolean;
}

export const PaginationControls: React.FC<IPaginationControlsProps> = ({
  pageSize,
  options,
  onPageSizeChange,
  PaginationComponent,
  disableItemsPerPage = false,
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, py: 3, px: 0 }}>
      {!disableItemsPerPage && <ItemsPerPage value={pageSize} options={options} onChange={onPageSizeChange} />}
      <Box
        sx={{
          marginRight: {
            sm: '10px',
            lg: '20px',
            xl: '26px',
          },
          '@media (min-width: 1920px)': {
            marginRight: '21px',
          },
        }}
      >
        <PaginationComponent />
      </Box>
    </Box>
  );
};
